import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { HEADER_FOOTER_CONTROLER_URL } from "api/Service";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useUpdateHeaderFooter = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");
  const handleNetworkError = useHandleNetworkError("Error saving header/footer");

  return useMutation({
    mutationFn: async (data) => {
      const axiosInstance = createAxiosInstance();

      await axiosInstance.post(
        `${tenantVal}${HEADER_FOOTER_CONTROLER_URL}`,
        { ...data, tenant: tenantVal },
        { headers: { "Content-Type": "application/json" } }
      );
    },
    onSuccess: () => {
      toast.success("Header & footer saved successfully.");
      queryClient.invalidateQueries({ queryKey: ["headerFooter", tenantVal] });
    },
    onError: handleNetworkError,
  });
};
